// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*고객 정보 팝업*/
.ReviewListPopup_review_list_popup__ITBrv{
    position: absolute;
    width: 512px;
    height: 834px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 17px 20px; box-sizing: border-box;
    z-index: 9999;
    display: block;
}

.ReviewListPopup_review_list_popup__ITBrv .ReviewListPopup_tit__A\\+pXn{
    font-size: 20px;
    font-weight: 500;
    padding-bottom:15px;
    display: flex;
    border-bottom: 1px solid #EBEBEB;
}

.ReviewListPopup_review_list_popup__ITBrv .ReviewListPopup_tit__A\\+pXn .ReviewListPopup_close_btn__STY\\+U{margin-left: auto;cursor: pointer;}
.ReviewListPopup_review_list_popup__ITBrv .ReviewListPopup_tit__A\\+pXn .ReviewListPopup_close_btn__STY\\+U svg{position: relative; top: 2px;}
.ReviewListPopup_review_list_popup__ITBrv .ReviewListPopup_tit__A\\+pXn .ReviewListPopup_title__lF-lj{color: black;}

.ReviewListPopup_review_list__Y-9\\+T {
    height:88%;
    overflow-x: hidden;
    overflow-y:scroll;
}

.ReviewListPopup_review_item__KEB8l {
    display: flex;
    min-height:100px;
    flex-direction: column;
    border-bottom: 1px solid #EBEBEB;
    margin: 5px 0;
}

.ReviewListPopup_review_item__KEB8l .ReviewListPopup_header__Ph2Vc {
    display:flex;
    padding-right:10px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.ReviewListPopup_header__Ph2Vc > div {
    display:flex;
    flex-direction:row;
    gap: 30px;
    padding: 5px 0px;
}

.ReviewListPopup_left__V3lXC > div {
    display:flex;
    flex-direction: row;
    gap: 10px;
}

.ReviewListPopup_left__V3lXC img {
    width:20px;
    height: 20px;
    border-radius: 50%;
}

.ReviewListPopup_right__oq\\+d\\+ > div {
    font-size:14px;
    color:#929292;
}
.ReviewListPopup_pagination__0tjJm {
    width:100%;
    display:flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top:15px;
    gap:15px;
}

.ReviewListPopup_pagination__0tjJm > button {
    padding: 5px 10px;
    font-size:14px;
}

.ReviewListPopup_body__PbuXO .ReviewListPopup_text__tPVb3 {
    margin-top: 5px;
    font-size: 14px;
    margin-bottom: 5px;
}

.ReviewListPopup_body__PbuXO .ReviewListPopup_gallery__\\+I0xr {
    display: flex;
    height: 150px;
    padding:0 5px;
    overflow-x: scroll; /* 가로 스크롤 활성화 */
    white-space: nowrap; /* 자식 요소들이 한 줄로 표시되도록 설정 */
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.ReviewListPopup_body__PbuXO .ReviewListPopup_gallery__\\+I0xr::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
}

.ReviewListPopup_gallery__\\+I0xr img {
    flex: 0 0 auto; 
    width: calc(97% / 2);
    height: auto;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 10px;
}

.ReviewListPopup_gallery__\\+I0xr img:last-child {
    margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ReviewListPopup.module.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,gDAAgD;IACxD,kBAAkB,EAAkC,sBAAsB;IAC1E,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IAGnB,aAAa;IACb,gCAAgC;AACpC;;AAEA,0GAAmC,iBAAiB,CAAC,eAAe,CAAC;AACrE,8GAAuC,kBAAkB,EAAE,QAAQ,CAAC;AACpE,qGAA+B,YAAY,CAAC;;AAE5C;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,aAAa;IACb,kBAAkB,EAAE,eAAe;IACnC,mBAAmB,EAAE,0BAA0B;IAC/C,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;;AAEA;IACI,aAAa,EAAE,0BAA0B;AAC7C;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/*고객 정보 팝업*/\n.review_list_popup{\n    position: absolute;\n    width: 512px;\n    height: 834px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n    padding: 17px 20px; -webkit-box-sizing: border-box; box-sizing: border-box;\n    z-index: 9999;\n    display: block;\n}\n\n.review_list_popup .tit{\n    font-size: 20px;\n    font-weight: 500;\n    padding-bottom:15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-bottom: 1px solid #EBEBEB;\n}\n\n.review_list_popup .tit .close_btn{margin-left: auto;cursor: pointer;}\n.review_list_popup .tit .close_btn svg{position: relative; top: 2px;}\n.review_list_popup .tit .title{color: black;}\n\n.review_list {\n    height:88%;\n    overflow-x: hidden;\n    overflow-y:scroll;\n}\n\n.review_item {\n    display: flex;\n    min-height:100px;\n    flex-direction: column;\n    border-bottom: 1px solid #EBEBEB;\n    margin: 5px 0;\n}\n\n.review_item .header {\n    display:flex;\n    padding-right:10px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.header > div {\n    display:flex;\n    flex-direction:row;\n    gap: 30px;\n    padding: 5px 0px;\n}\n\n.left > div {\n    display:flex;\n    flex-direction: row;\n    gap: 10px;\n}\n\n.left img {\n    width:20px;\n    height: 20px;\n    border-radius: 50%;\n}\n\n.right > div {\n    font-size:14px;\n    color:#929292;\n}\n.pagination {\n    width:100%;\n    display:flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    margin-top:15px;\n    gap:15px;\n}\n\n.pagination > button {\n    padding: 5px 10px;\n    font-size:14px;\n}\n\n.body .text {\n    margin-top: 5px;\n    font-size: 14px;\n    margin-bottom: 5px;\n}\n\n.body .gallery {\n    display: flex;\n    height: 150px;\n    padding:0 5px;\n    overflow-x: scroll; /* 가로 스크롤 활성화 */\n    white-space: nowrap; /* 자식 요소들이 한 줄로 표시되도록 설정 */\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n\n.body .gallery::-webkit-scrollbar {\n    display: none; /* Chrome, Safari, Opera */\n}\n\n.gallery img {\n    flex: 0 0 auto; \n    width: calc(97% / 2);\n    height: auto;\n    border-radius: 10px;\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.gallery img:last-child {\n    margin-right: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"review_list_popup": `ReviewListPopup_review_list_popup__ITBrv`,
	"tit": `ReviewListPopup_tit__A+pXn`,
	"close_btn": `ReviewListPopup_close_btn__STY+U`,
	"title": `ReviewListPopup_title__lF-lj`,
	"review_list": `ReviewListPopup_review_list__Y-9+T`,
	"review_item": `ReviewListPopup_review_item__KEB8l`,
	"header": `ReviewListPopup_header__Ph2Vc`,
	"left": `ReviewListPopup_left__V3lXC`,
	"right": `ReviewListPopup_right__oq+d+`,
	"pagination": `ReviewListPopup_pagination__0tjJm`,
	"body": `ReviewListPopup_body__PbuXO`,
	"text": `ReviewListPopup_text__tPVb3`,
	"gallery": `ReviewListPopup_gallery__+I0xr`
};
export default ___CSS_LOADER_EXPORT___;
